module.exports = __webpack_public_path__ + "img/expodecor_aqua.6e77ae31.jpg";